import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DBOptionSet } from '../../models/stack9/OptionSet';
import { OptionSetDrawer } from '../OptionSetDrawer/OptionSetDrawer';

const S9Button = ui.S9Button.default;

const { useRefreshList } = ui;

export const config: S9ComponentConfig = {
  name: 'OptionSetAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type OptionSetActionProps = {
  row: DBOptionSet;
};
const OptionSetAction = ({ row }: OptionSetActionProps) => {
  const refresh = useRefreshList();

  const [drawerState, setDrawerState] = useState<{
    id?: number;
    open: boolean;
  }>({ open: false });

  return (
    <>
      <S9Button
        type="link"
        style={{ width: '100%', textAlign: 'left' }}
        onClick={() => setDrawerState({ id: row.id, open: true })}
        label={`${row.option}`}
      />
      <OptionSetDrawer
        initialValues={row}
        id={row.id}
        open={drawerState.open}
        onClose={() => {
          setDrawerState({ id: undefined, open: false });
          refresh();
        }}
      />
    </>
  );
};

export default OptionSetAction;
